<template>
    <nav
        class="navbar has-shadow is-fixed-top"
        role="navigation"
        aria-label="main navigation"
        
    >
        <div class="navbar-brand" >
            <router-link
                v-if="!hideLogin"
                :to="{
                    path: hasDashboardAccess ? '/dashboard' : '/',
                    query: hasDashboardAccess ? {filter: 'mine'} : ''
                }"
                class="navbar-item is-family-secondary has-text-primary title is-4 is-marginless"
                exact
            >
                <span
                    class="is-family-primary is-size-6 pr-1 is-hidden-mobile"
                    >{{ $t('App.navbar_back_to') }}</span
                >
                <span class="icon is-medium is-hidden-tablet pr-1">
                    <i class="mdi mdi-24px mdi-chevron-left"></i
                ></span>
                <span class="is-hidden-mobile"
                    ><img
                        src="@/assets/images/Labylok.gif"
                        alt=""
                        width="112"
                        height="28"
                /></span>
            </router-link>
            <div class="container" >
                <div
                    class="is-hidden-tablet is-hidden-desktop navbar-item py-0"
                >
                    <div :class="isLoggedIn ? 'lb-centered' : 'container'" >
                        <ProjectNavbarActions
                            v-if="!isGame"
                            :hide-login="hideLogin"
                            class="navbar-item is-pulled-right"
                            @information="$emit('information')"
                            @share="$emit('share')"
                        />
                    </div>
                    <div
                        v-if="
                            !isLoggedIn && windowSize == 'mobile' && !hideLogin
                        "
                        class="container"
                    >
                        <app-navbar-user-menu  class="is-pulled-right" />
                    </div>
                </div>
            </div>
            <a
                v-if="!hideLogin && (isLoggedIn || windowSize !== 'mobile')"
                role="button"
                class="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbar"
                @click="menuActive = !menuActive"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div
            :class="{ 'is-active': menuActive }"
            class="navbar-menu"
            @click="menuActive = false"
        >
            <div class="navbar-start"></div>
            <p
                class="navbar-item is-size-4 is-family-secondary is-hidden-mobile"
            >
                {{ project.title }}
            </p>
            <ProjectNavbarActions
            v-if="!isGame"
                :hide-login="hideLogin"
                class="is-hidden-mobile"
                @information="$emit('information')"
                @share="$emit('share')"
            />
            <div class="navbar-end">
                <app-navbar-user-menu
                    v-if="!hideLogin && (isLoggedIn || windowSize !== 'mobile')"
                />
            </div>
        </div>
    </nav>
</template>

<script>
import AppNavbarUserMenu from '@/components/AppNavbarUserMenu';
import ProjectNavbarActions from '@/components/ProjectNavbarActions';
export default {
    components: {
        AppNavbarUserMenu,
        ProjectNavbarActions,
    },
    props: {
        hideLogin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menuActive: false,
        };
    },
    computed: {
        project() {
            return this.$store.getters.project;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        windowSize() {
            return this.$mq;
        },
        hasDashboardAccess(){
            return this.isLoggedIn && !this.$store.getters.isAnonymous;
        },
        isGame(){
            return this.$route.name==='play'
        }
    },
    mounted() {
        console.log(this.$route.meta.hideLogin);
        console.log(this.hideLogin);
    },
};
</script>

<style></style>
